/**
 * Firebase web config from Create React App env (must be prefixed REACT_APP_).
 * Copy values from Firebase Console → Project settings → Your apps → Web app config.
 */
export type FirebaseWebConfig = {
  apiKey: string;
  authDomain: string;
  projectId: string;
  storageBucket: string;
  messagingSenderId: string;
  appId: string;
  measurementId?: string;
};

export function getFirebaseWebConfig(): FirebaseWebConfig | null {
  const apiKey = process.env.REACT_APP_FIREBASE_API_KEY;
  const authDomain = process.env.REACT_APP_FIREBASE_AUTH_DOMAIN;
  const projectId = process.env.REACT_APP_FIREBASE_PROJECT_ID;
  const storageBucket = process.env.REACT_APP_FIREBASE_STORAGE_BUCKET;
  const messagingSenderId = process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID;
  const appId = process.env.REACT_APP_FIREBASE_APP_ID;

  if (
    !apiKey ||
    !authDomain ||
    !projectId ||
    !storageBucket ||
    !messagingSenderId ||
    !appId
  ) {
    return null;
  }

  const config: FirebaseWebConfig = {
    apiKey,
    authDomain,
    projectId,
    storageBucket,
    messagingSenderId,
    appId,
  };

  if (process.env.REACT_APP_FIREBASE_MEASUREMENT_ID) {
    config.measurementId = process.env.REACT_APP_FIREBASE_MEASUREMENT_ID;
  }

  return config;
}

export function isFirebaseConfigured(): boolean {
  return getFirebaseWebConfig() !== null;
}

/** Names of `REACT_APP_*` vars required for web SDK init (for diagnostics). */
export const FIREBASE_WEB_ENV_KEYS = [
  'REACT_APP_FIREBASE_API_KEY',
  'REACT_APP_FIREBASE_AUTH_DOMAIN',
  'REACT_APP_FIREBASE_PROJECT_ID',
  'REACT_APP_FIREBASE_STORAGE_BUCKET',
  'REACT_APP_FIREBASE_MESSAGING_SENDER_ID',
  'REACT_APP_FIREBASE_APP_ID',
] as const;

/** Which required env vars are missing (empty array means `isFirebaseConfigured()` is true). */
export function getMissingFirebaseWebEnvKeys(): string[] {
  return FIREBASE_WEB_ENV_KEYS.filter((key) => !process.env[key]);
}
